import React from "react"

const blogs = () => {
  return (
    <div>
      
    </div>
  )
}

export default blogs;